import React, { Component } from 'react';
import { useIntl } from 'react-intl';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    FormGroup, Label, Input, Button,
    Row, Col} from 'reactstrap';
import IntlMessage from '../../../../../helpers/intlMessage';

function ModalJustificativaCancelamento(props) {
    const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
        return (
            <Modal
                centered
                isOpen={props.showModalCancelamentoEntrega}
                toggle={props.toggleModalCancelamentoEntrega}>
                <ModalHeader toggle={props.toggleModalCancelamentoEntrega}>
                    <IntlMessage id = "dashboards.examDetail.deliveryCancellation"/>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup className="justificativa-cancelar">
                                <Label><IntlMessage id = "dashboards.examDetail.justificationCancellation"/></Label>
                                <Input
                                    type="textarea"
                                    name="text"
                                    placeholder={translate("dashboards.examDetail.justificationForCancellation")}
                                    onChange={props.setJustificativaCancelamentoEntrega}
                                    value={props.justificativaCancelamentoEntrega}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={props.toggleModalCancelamentoEntrega} color="secondary">
                        <IntlMessage id = "dashboards.examDetail.comeBack"/>
                    </Button>
                    <Button
                        onClick={props.cancelarEntrega}
                        disabled={!props.justificativaCancelamentoEntrega}
                        color="primary">
                        <IntlMessage id = "dashboards.examDetail.cancelStep"/>
                </Button>
                </ModalFooter>
            </Modal>
        )
    }

export default ModalJustificativaCancelamento;


// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/entrega/modal.justificativa.cancelamento.js